import { Routes, Route } from "react-router-dom";
import { ModalProvider } from "./components/ModalProvider";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import PrivacyPage from "./pages/PrivacyPage";

export default function App() {
  return (
    <ModalProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/uslugi" element={<ServicesPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
      </Routes>
    </ModalProvider>
  );
}
